export const TAG_TYPE_OPTIONS = [
  { value: "jobs", label: "Jobs" },
  { value: "customers", label: "Customers" },
  { value: "clients", label: "Clients" },
  { value: "users", label: "Users" },
  { value: "drivers", label: "Drivers" },
  { value: "employees", label: "Employees" },
  { value: "equipment", label: "Equipment" },
  // { value: "inventory", label: "Inventory" },
  { value: "invoices", label: "Invoices" },
  { value: "manifests", label: "Manifests" },
  { value: "payouts", label: "Payouts" },
  { value: "reports", label: "Reports" },
  { value: "feedback", label: "Feedback" },
  { value: "organizations", label: "Organizations" },
  { value: "leads", label: "Leads" },
  { value: "tasks", label: "Tasks" },
];

const TAG_TYPE_META = TAG_TYPE_OPTIONS.reduce(
  (map, option) => ({
    ...map,
    [option.value]: option,
  }),
  {},
);

/**
 * Normalize appliesTo from API or legacy single-value shapes.
 * @param {string|string[]|undefined} value
 * @returns {string[]}
 */
export function normalizeAppliesToDraft(value) {
  const raw = Array.isArray(value)
    ? value
    : typeof value === "string" && value.trim()
      ? value.split(",").map((item) => item.trim())
      : [];

  const normalized = raw.filter((item) => TAG_TYPE_META[item]);
  return Array.from(new Set(normalized));
}

/**
 * @param {object} [tag]
 */
export function buildTagDraft(tag = {}) {
  return {
    name: tag.name || "",
    color: tag.color || "#64748b",
    description: tag.description || "",
    appliesTo: normalizeAppliesToDraft(tag.appliesTo),
  };
}

export function getTagTypeLabel(type) {
  return TAG_TYPE_META[type]?.label || type;
}

export const TAG_FILTER_OPTIONS = TAG_TYPE_OPTIONS.map((option) => ({
  _id: option.value,
  name: option.label,
}));

export const TAG_TYPE_COLORS = {
  jobs: "blue",
  customers: "purple",
  clients: "teal",
  users: "indigo",
  drivers: "orange",
  employees: "emerald",
  equipment: "slate",
  inventory: "cyan",
  invoices: "green",
  manifests: "amber",
  payouts: "lime",
  reports: "sky",
  feedback: "rose",
  organizations: "fuchsia",
  leads: "pink",
  tasks: "gray",
};
